import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingAnimationService {

  loaderSubject = new Subject<boolean>();

  constructor() { 
    this.loaderSubject.subscribe({
      next: (value) => {

      }, 
      error: (error) => {

      },
      complete: () => {

      }
    });
  }

  show() {
    this.loaderSubject.next(true);
  }

  hide() {
    this.loaderSubject.next(false);
  }
}
